import { select } from './utils/dom';
import { isMobile } from './utils/breakpoint';
import { keyCodes } from './constants/keyboard';

class LoginModal {
  constructor() {
    this.button = select('.loginModalTrigger');
    this.modal = select('.LoginModal');
    if (this.button && this.modal) {
      this.setup();
      this.handleButtonEnter = this.handleButtonEnter.bind(this);
      this.handleButtonLeave = this.handleButtonLeave.bind(this);
      this.handleModalEnter = this.handleModalEnter.bind(this);
      this.handleModalLeave = this.handleModalLeave.bind(this);
      this.waitToHide = this.waitToHide.bind(this);
      this.bindEvents();
    }
  }

  /**
   * Setup some initial state variables
   */
  setup() {
    this.isButtonHovered = false;
    this.isModalHovered = false;
    this.isModalShown = false;
  }

  /**
   * Add event listeners
   */
  bindEvents() {
    // mouse events enter and leave
    this.button.addEventListener('mouseenter', this.handleButtonEnter);
    this.button.addEventListener('mouseleave', this.handleButtonLeave);
    this.modal.addEventListener('mouseenter', this.handleModalEnter);
    this.modal.addEventListener('mouseleave', this.handleModalLeave);

    // whenever a transition ends reset visibility of modal
    // this allows the fade out effect to complete.
    this.modal.addEventListener('transitionend', () => {
      if (!this.isModalShown) {
        this.modal.style.visibility = 'hidden';
        this.modal.style.display = 'none';
        this.modal.style.top = 'auto';
        this.modal.style.right = 'auto';
      }
    });

    // escape key should close the modal
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === keyCodes.escape) {
        this.closeModal();
      }
    });
  }

  /**
   * Cache the computed style for the button
   */
  getButtonRect() {
    return this.button.getBoundingClientRect();
  }

  /**
   * Get the window width
   */
  getWindowWidth() { // eslint-disable-line class-methods-use-this
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  }

  /**
   * Open the modal
   */
  openModal() {
    const buttonRect = this.getButtonRect();
    const windowWidth = this.getWindowWidth();
    this.modal.style.position = 'fixed';
    this.modal.style.visibility = 'visible';
    this.modal.style.display = 'block';
    this.modal.classList.add('is-open');
    this.modal.style.right = `${windowWidth - buttonRect.right}px`;
    this.modal.style.top = `calc(${buttonRect.top + buttonRect.height}px + 1vw)`;
    this.isModalShown = true;
  }

  /**
   * Close the modal
   */
  closeModal() {
    this.modal.classList.remove('is-open');
    this.isModalShown = false;
  }

  /**
   * Callback for waiting to hide
   */
  waitToHide() {
    if (!this.isButtonHovered && !this.isModalHovered) {
      this.closeModal();
    }
  }

  /**
   * Handle mouse enter into button
   */
  handleButtonEnter() {
    this.isButtonHovered = true;
    if (!this.isModalShown) {
      this.openModal();
    }
  }

  /**
   * Handle button leave event
   */
  handleButtonLeave() {
    this.isButtonHovered = false;
    setTimeout(this.waitToHide, 75);
  }

  /**
   * Handle mouse enter into open modal
   */
  handleModalEnter() {
    this.isModalHovered = true;
  }

  /**
   * Handle mouse leave modal
   */
  handleModalLeave() {
    // don't hide the modal if the input is focused
    // because sometimes autocomplete selection was causing the modal to close
    if (document.querySelector('input') !== document.activeElement) {
      this.isModalHovered = false;
      // wait before hiding to give the user a chance to re-enter the button or modal to save it from hiding.
      setTimeout(this.waitToHide, 75);
    }
  }
}

// export functionality since it could be used more than once.
export default function () {
  if (!isMobile) {
    new LoginModal(); // eslint-disable-line no-new
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/loginModal.js